import React from 'react';
import { PropTypes } from 'prop-types';
import PasswordInput from './PasswordInput';

export default {
  title: 'Components/Inputs/PasswordInput',
  component: PasswordInput,
  tags: ['autodocs'],
};

// Base Template function for stories
const PasswordInputTemplate = ({
  label, name, errorMessage = '', isNewPassword = false, validPassword = '', defaultValue = '', extraInfo, isRequired = false, isValid = true,
}) => {
  const [value, setValue] = React.useState(defaultValue);
  const validate = () => {
    if (!value) return true;
    return value === validPassword;
  };

  return (
    <PasswordInput
      value={value}
      setValue={setValue}
      label={label}
      name={name}
      errorMessage={errorMessage}
      isNewPassword={isNewPassword}
      isValid={!isValid ? false : validate()}
      extraInfo={extraInfo}
      isRequired={isRequired}
    />
  );
};

// Binding the base template
const Template = PasswordInputTemplate.bind({});

// Creating stories by applying different props

export const CurrentPassword = Template.bind({});
CurrentPassword.args = {
  label: 'Current password',
  name: 'label',
  errorMessage: 'Password does not match.',
  validPassword: '1!aAaa',
  extraInfo: 'Your current password is required to save changes.',
  isRequired: true,
  isValid: true,
};

export const InvalidEmptyPassword = Template.bind({});
InvalidEmptyPassword.args = {
  label: 'Current password',
  name: 'label',
  errorMessage: 'Please enter your current password to save changes.',
  validPassword: '1!aAaa',
  extraInfo: 'Your current password is required to save changes.',
  isRequired: true,
  isValid: false,
};

export const NewPassword = Template.bind({});
NewPassword.args = {
  label: 'New password',
  name: 'label',
  errorMessage: 'Please add all necessary criteria to create a safe password.',
  isNewPassword: true,
};

export const ConfirmPassword = Template.bind({});
ConfirmPassword.args = {
  label: 'Confirm new password',
  name: 'label',
  errorMessage: 'Password does not match.',
  validPassword: '1!aAaa',
  defaultValue: '1!aAaa',
  isValid: true,
};

export const ConfirmPasswordInvalid = Template.bind({});
ConfirmPasswordInvalid.args = {
  label: 'Confirm new password',
  name: 'label',
  errorMessage: 'Password does not match.',
  newPassword: '1!aAaa',
  defaultValue: '1!1111',
};

PasswordInputTemplate.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  isNewPassword: PropTypes.bool,
  validPassword: PropTypes.string,
  defaultValue: PropTypes.string,
  extraInfo: PropTypes.string,
  isValid: PropTypes.bool,
  isRequired: PropTypes.bool,
};
